import React, { Component } from 'react';
import { valuesToHtmlString } from './helpers/iframeHelpers';

class Iframe extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.envelope) { this._renderIframe(nextProps.envelope); }
  }
  componentDidMount() {
    if (this.props.envelope) { this._renderIframe(this.props.envelope); }
  }
  render() {
    return (
      <iframe
        style={this.props.styleProps}
        ref="iframe"
      />
    )
  }
  _renderIframe = (envelope) => {
    var doc = this.refs.iframe.contentDocument;
    doc.open();
    doc.write(valuesToHtmlString(envelope));
    doc.close();
  }
}

export default Iframe;



// WEBPACK FOOTER //
// ./src/_NewIframeEmbedMobile.js